import { render, staticRenderFns } from "./CustomerSearchForm.vue?vue&type=template&id=4387bb45&"
import script from "./CustomerSearchForm.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports